/**
 * @generated SignedSource<<1732b50d112deb095cf06bfd2dce94ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TVTodoEditAssigneesPopoverMutation$variables = {
  assignees: ReadonlyArray<string>;
  employeeId?: string | null;
  id: string;
};
export type TVTodoEditAssigneesPopoverMutation$data = {
  readonly todo: {
    readonly updateAssignedEmployees: {
      readonly assigned: ReadonlyArray<{
        readonly employee: {
          readonly id: string;
        } | null;
      }>;
      readonly id: string;
    };
  } | null;
};
export type TVTodoEditAssigneesPopoverMutation$rawResponse = {
  readonly todo: {
    readonly updateAssignedEmployees: {
      readonly assigned: ReadonlyArray<{
        readonly employee: {
          readonly id: string;
        } | null;
        readonly id: string;
      }>;
      readonly id: string;
    };
  } | null;
};
export type TVTodoEditAssigneesPopoverMutation = {
  rawResponse: TVTodoEditAssigneesPopoverMutation$rawResponse;
  response: TVTodoEditAssigneesPopoverMutation$data;
  variables: TVTodoEditAssigneesPopoverMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "assignees"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "employeeId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = [
  {
    "kind": "Variable",
    "name": "employeeId",
    "variableName": "employeeId"
  },
  {
    "kind": "Variable",
    "name": "todoId",
    "variableName": "id"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "updateAssignedEmployeeIds",
    "variableName": "assignees"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Employee",
  "kind": "LinkedField",
  "name": "employee",
  "plural": false,
  "selections": [
    (v5/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TVTodoEditAssigneesPopoverMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TodoMutation",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "updateAssignedEmployees",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AssignedEmployee",
                "kind": "LinkedField",
                "name": "assigned",
                "plural": true,
                "selections": [
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "TVTodoEditAssigneesPopoverMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TodoMutation",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "updateAssignedEmployees",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AssignedEmployee",
                "kind": "LinkedField",
                "name": "assigned",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "760d766957cb84afb3a910ee18a75659",
    "id": null,
    "metadata": {},
    "name": "TVTodoEditAssigneesPopoverMutation",
    "operationKind": "mutation",
    "text": "mutation TVTodoEditAssigneesPopoverMutation(\n  $id: ID!\n  $assignees: [ID!]!\n  $employeeId: ID\n) {\n  todo(todoId: $id, employeeId: $employeeId) {\n    updateAssignedEmployees(updateAssignedEmployeeIds: $assignees) {\n      id\n      assigned {\n        employee {\n          id\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4c2b502a8826ec29752e0e6a95b67df8";

export default node;
